import { InitialState } from '../state';
import { customerData } from '../state/assets-state';
import { AppReducer } from './app-reducer';

export const assetReducer: AppReducer<'Asset'> = (state = InitialState.Asset, action): typeof state => {
    switch (action.type) {
        case 'Asset/deviceList/Started':
            return {
                ...state,
                deviceListLoading: true,
                deviceListSuccess: false,
                deviceListFail: false,
                deviceListErrorCode: '',
            };
        case 'Asset/deviceList/Succeeded':
            return {
                ...state,
                deviceListLoading: false,
                deviceListSuccess: true,
                deviceListFail: false,
                deviceListErrorCode: '',
                deviceList: action.payload.deviceList,
            };
        case 'Asset/deviceList/Failed':
            return {
                ...state,
                deviceListLoading: false,
                deviceListSuccess: false,
                deviceListFail: true,
                deviceListErrorCode: action.payload.errorCode,
            };
        case 'Asset/deviceList/Unmounted':
            return {
                ...state,
                deviceListLoading: false,
                deviceListSuccess: false,
                deviceListFail: false,
                deviceListErrorCode: '',
            };
        case 'Asset/whitelistzone/Started':
            return {
                ...state,
                whitelistzoneLoading: true,
                whitelistzoneSuccess: false,
                whitelistzoneFail: false,
                whitelistzoneErrorCode: '',
            };
        case 'Asset/whitelistzone/Succeeded':
            return {
                ...state,
                whitelistzoneLoading: false,
                whitelistzoneSuccess: true,
                whitelistzoneFail: false,
                whitelistzoneErrorCode: '',
                whitelistZoneId: action.payload.id,
                whitelistZoneMessage: action.payload.message,
            };
        case 'Asset/whitelistzone/Failed':
            return {
                ...state,
                whitelistzoneLoading: false,
                whitelistzoneSuccess: false,
                whitelistzoneFail: true,
                whitelistzoneErrorCode: action.payload.errorCode,
            };
        case 'Asset/whitelistzone/Unmounted':
            return {
                ...state,
                whitelistzoneLoading: false,
                whitelistzoneSuccess: false,
                whitelistzoneFail: false,
                whitelistzoneErrorCode: '',
                whitelistZoneMessage: '',
                whitelistZoneId: '',
            };

        case 'Asset/getDeviceWhitelistZoneData/Started':
            return {
                ...state,
                deviceGetWhitelistZoneLoading: true,
                deviceGetWhitelistZoneSuccess: false,
                deviceGetWhitelistZoneFail: false,
                deviceGetWhitelistZoneErrorCode: '',
            };

        case 'Asset/getDeviceWhitelistZoneData/Succeeded':
            return {
                ...state,
                deviceGetWhitelistZoneLoading: false,
                deviceGetWhitelistZoneSuccess: true,
                deviceGetWhitelistZoneFail: false,
                deviceGetWhitelistZoneErrorCode: '',
                deviceGetWhitelistZone: action.payload.whitelistZoneData,
            };

        case 'Asset/getDeviceWhitelistZoneData/Failed':
            return {
                ...state,
                deviceGetWhitelistZoneLoading: false,
                deviceGetWhitelistZoneSuccess: false,
                deviceGetWhitelistZoneFail: true,
                deviceGetWhitelistZoneErrorCode: action.payload.errorCode,
            };

        case 'Asset/getDeviceWhitelistZoneData/Unmounted':
            return {
                ...state,
                deviceGetWhitelistZoneLoading: false,
                deviceGetWhitelistZoneSuccess: false,
                deviceGetWhitelistZoneFail: false,
                deviceGetWhitelistZoneErrorCode: '',
            };

        case 'Asset/getDeviceWhitelistDetail/Started':
            return {
                ...state,
                getWhitelistDetailLoading: true,
                getWhitelistDetailSuccess: false,
                getWhitelistDetailFail: false,
                getWhitelistDetailErrorCode: '',
            };

        case 'Asset/getDeviceWhitelistDetail/Succeeded':
            return {
                ...state,
                getWhitelistDetailLoading: false,
                getWhitelistDetailSuccess: true,
                getWhitelistDetailFail: false,
                getWhitelistDetailErrorCode: '',
                getWhitelistDetail: action.payload.whitelistDetail,
            };

        case 'Asset/getDeviceWhitelistDetail/Failed':
            return {
                ...state,
                getWhitelistDetailLoading: false,
                getWhitelistDetailSuccess: false,
                getWhitelistDetailFail: true,
                getWhitelistDetailErrorCode: action.payload.errorCode,
            };

        case 'Asset/getDeviceWhitelistDetail/Unmounted':
            return {
                ...state,
                getWhitelistDetailLoading: false,
                getWhitelistDetailSuccess: false,
                getWhitelistDetailFail: false,
                getWhitelistDetailErrorCode: '',
            };

        case 'Customer/deviceCustomerData/Started':
            return {
                ...state,
                deviceCustomerDataLoading: true,
                deviceCustomerDataSuccess: false,
                deviceCustomerDataFail: false,
                deviceCustomerDataErrorCode: '',
            };
        case 'Customer/deviceCustomerData/Succeeded':
            return {
                ...state,
                deviceCustomerDataLoading: false,
                deviceCustomerDataSuccess: true,
                deviceCustomerDataFail: false,
                deviceCustomerDataErrorCode: '',
                deviceCustomerData: action.payload.customerData,
            };
        case 'Customer/deviceCustomerData/Failed':
            return {
                ...state,
                deviceCustomerDataLoading: false,
                deviceCustomerDataSuccess: false,
                deviceCustomerDataFail: true,
                deviceCustomerDataErrorCode: action.payload.errorCode,
            };

        case 'Customer/deviceCustomerData/Unmounted':
            return {
                ...state,
                deviceCustomerDataLoading: false,
                deviceCustomerDataSuccess: false,
                deviceCustomerDataFail: false,
                deviceCustomerDataErrorCode: '',
                deviceCustomerData: customerData
            };
        case 'Customer/updateCustomerDetail/Started':
            return {
                ...state,
                updateCustomerDetailLoading: true,
                updateCustomerDetailSuccess: false,
                updateCustomerDetailFail: false,
                updateCustomerDetailErrorMessage: '',
            };
        case 'Customer/updateCustomerDetail/Succeeded':
            return {
                ...state,
                updateCustomerDetailLoading: false,
                updateCustomerDetailSuccess: true,
                updateCustomerDetailFail: false,
                updateCustomerDetailErrorMessage: '',
                updateCustomerDetailId: action.payload.id
            };
        case 'Customer/updateCustomerDetail/Failed':
            return {
                ...state,
                updateCustomerDetailLoading: false,
                updateCustomerDetailSuccess: false,
                updateCustomerDetailFail: true,
                updateCustomerDetailErrorMessage: action.payload.errorCode,
            };

        case 'Customer/updateCustomerDetail/Unmounted':
            return {
                ...state,
                updateCustomerDetailLoading: false,
                updateCustomerDetailSuccess: false,
                updateCustomerDetailFail: false,
                updateCustomerDetailErrorMessage: '',
                updateCustomerDetailId: ''
            };

        case 'Asset/luminaryList/Started':
            return {
                ...state,
                luminaryListLoading: true,
                luminaryListSuccess: false,
                luminaryListFail: false,
                luminaryListErrorCode: '',
            };
        case 'Asset/luminaryList/Succeeded':
            return {
                ...state,
                luminaryListLoading: false,
                luminaryListSuccess: true,
                luminaryListFail: false,
                luminaryListErrorCode: '',
                luminaryList: action.payload.luminaryListData,
            };
        case 'Asset/luminaryList/Failed':
            return {
                ...state,
                luminaryListLoading: false,
                luminaryListSuccess: false,
                luminaryListFail: true,
                luminaryListErrorCode: action.payload.errorCode,
            };

        case 'Asset/luminaryList/Unmounted':
            return {
                ...state,
                luminaryListLoading: false,
                luminaryListSuccess: false,
                luminaryListFail: false,
                luminaryListErrorCode: '',
            };
        case 'Asset/gatewayDetailsList/Started':
            return {
                ...state,
                gatewayDetailsListLoading: true,
                gatewayDetailsListSuccess: false,
                gatewayDetailsListFail: false,
                gatewayDetailsListErrorCode: '',
            };
        case 'Asset/gatewayDetailsList/Succeeded':
            return {
                ...state,
                gatewayDetailsListLoading: false,
                gatewayDetailsListSuccess: true,
                gatewayDetailsListFail: false,
                gatewayDetailsListErrorCode: '',
                gatewayDetailsList: action.payload.gatewayDetailsList,
            };
        case 'Asset/gatewayDetailsList/Failed':
            return {
                ...state,
                gatewayDetailsListLoading: false,
                gatewayDetailsListSuccess: false,
                gatewayDetailsListFail: true,
                gatewayDetailsListErrorCode: action.payload.errorCode,
            };

        case 'Asset/gatewayDetailsList/Unmounted':
            return {
                ...state,
                gatewayDetailsListLoading: false,
                gatewayDetailsListSuccess: false,
                gatewayDetailsListFail: false,
                gatewayDetailsListErrorCode: '',
            };

        case 'Asset/slaList/Started':
            return {
                ...state,
                slaListLoading: true,
                slaListSuccess: false,
                slaListFail: false,
                slaListErrorCode: '',
            };
        case 'Asset/slaList/Succeeded':
            return {
                ...state,
                slaListLoading: false,
                slaListSuccess: true,
                slaListFail: false,
                slaListErrorCode: '',
                slaList: action.payload.SLADetailsList,
            };
        case 'Asset/slaList/Failed':
            return {
                ...state,
                slaListLoading: false,
                slaListSuccess: false,
                slaListFail: true,
                slaListErrorCode: action.payload.errorCode,
            };

        case 'Asset/slaList/Unmounted':
            return {
                ...state,
                slaListLoading: false,
                slaListSuccess: false,
                slaListFail: false,
                slaListErrorCode: '',
            };

        case 'Asset/maintenanceTicketList/Started':
            return {
                ...state,
                slaListLoading: true,
                slaListSuccess: false,
                slaListFail: false,
                slaListErrorCode: '',
            };
        case 'Asset/maintenanceTicketList/Succeeded':
            return {
                ...state,
                maintenanceTicketListDataLoading: false,
                maintenanceTicketListDataSuccess: true,
                maintenanceTicketListDataFail: false,
                maintenanceTicketListErrorCode: '',
                maintenanceTicketListData: action.payload.MaintenanceTicketDetailListData,
            };
        case 'Asset/maintenanceTicketList/Failed':
            return {
                ...state,
                slaListLoading: false,
                slaListSuccess: false,
                slaListFail: true,
                slaListErrorCode: action.payload.errorCode,
            };

        case 'Asset/maintenanceTicketList/Unmounted':
            return {
                ...state,
                slaListLoading: false,
                slaListSuccess: false,
                slaListFail: false,
                slaListErrorCode: '',
            };

        case 'Asset/slaCustomerDetails/Started':
            return {
                ...state,
                slaCustomerListLoading: true,
                slaCustomerListSuccess: false,
                slaCustomerListFail: false,
                slaCustomerListErrorCode: '',
            };
        case 'Asset/slaCustomerDetails/Succeeded':
            return {
                ...state,
                slaCustomerListLoading: false,
                slaCustomerListSuccess: true,
                slaCustomerListFail: false,
                slaCustomerListErrorCode: '',
                slaCustomerList: action.payload.customerDetailsList,
            };

        case 'Asset/slaCustomerDetails/Failed':
            return {
                ...state,
                slaCustomerListLoading: false,
                slaCustomerListSuccess: false,
                slaCustomerListFail: true,
                slaCustomerListErrorCode: action.payload.errorCode,
            };

        case 'Asset/slaCustomerDetails/Unmounted':
            return {
                ...state,
                slaCustomerListLoading: false,
                slaCustomerListSuccess: false,
                slaCustomerListFail: false,
                slaCustomerListErrorCode: '',
            };

        case 'Asset/firePanelList/Started':
            return {
                ...state,
                firePanelListLoading: true,
                firePanelListSuccess: false,
                firePanelListFail: false,
                firePanelListErrorCode: '',
            };
        case 'Asset/firePanelList/Succeeded':
            return {
                ...state,
                firePanelListLoading: false,
                firePanelListSuccess: true,
                firePanelListFail: false,
                firePanelListErrorCode: '',
                firePanelList: action.payload.firePanelList,
            };
        case 'Asset/firePanelList/Failed':
            return {
                ...state,
                firePanelListLoading: false,
                firePanelListSuccess: false,
                firePanelListFail: true,
                firePanelListErrorCode: action.payload.errorCode,
            };
        case 'Asset/firePanelList/Unmounted':
            return {
                ...state,
                firePanelListLoading: false,
                firePanelListSuccess: false,
                firePanelListFail: false,
                deviceListErrorCode: '',
            };
        case 'Asset/configureLuminairesList/Started':
            return {
                ...state,
                configureLuminariesListLoading: true,
                configureLuminariesListSuccess: false,
                configureLuminariesListFail: false,
                configureLuminariesListErrorCode: '',
            };
        case 'Asset/configureLuminairesList/Succeeded':
            return {
                ...state,
                configureLuminariesListLoading: false,
                configureLuminariesListSuccess: true,
                configureLuminariesListFail: false,
                configureLuminariesListErrorCode: '',
                configureLuminariesListDetails: action.payload.configLumnList,
            };
        case 'Asset/configureLuminairesList/Failed':
            return {
                ...state,
                configureLuminariesListLoading: false,
                configureLuminariesListSuccess: false,
                configureLuminariesListFail: true,
                configureLuminariesListErrorCode: action.payload.errorCode,
            };
        case 'Asset/configureLuminairesList/Unmounted':
            return {
                ...state,
                configureLuminariesListLoading: false,
                configureLuminariesListSuccess: false,
                configureLuminariesListFail: false,
                configureLuminariesListErrorCode: '',
            };
        case 'Asset/setConfigureLuminairesList/Started':
            return {
                ...state,
                setConfigureLuminariesListLoading: true,
                setConfigureLuminariesListSuccess: false,
                setConfigureLuminariesListFail: false,
                setConfigureLuminariesListErrorCode: '',
            };
        case 'Asset/setConfigureLuminairesList/Succeeded':
            return {
                ...state,
                setConfigureLuminariesListLoading: false,
                setConfigureLuminariesListSuccess: true,
                setConfigureLuminariesListFail: false,
                setConfigureLuminariesListErrorCode: '',
                setConfigureLuminariesMessage: action.payload.message,
            };
        case 'Asset/setConfigureLuminairesList/Failed':
            return {
                ...state,
                setConfigureLuminariesListLoading: false,
                setConfigureLuminariesListSuccess: false,
                setConfigureLuminariesListFail: true,
                setConfigureLuminariesListErrorCode: action.payload.errorCode,
            };
        case 'Asset/setConfigureLuminairesList/Unmounted':
            return {
                ...state,
                setConfigureLuminariesListLoading: false,
                setConfigureLuminariesListSuccess: false,
                setConfigureLuminariesListFail: false,
                setConfigureLuminariesListErrorCode: '',
            };
        case 'Asset/getIoConfigDetails/Started':
            return {
                ...state,
                getIoConfigDetailsLoading: true,
                getIoConfigDetailsSuccess: false,
                getIoConfigDetailsFail: false,
                getIoConfigDetailsErrorCode: '',
            };
        case 'Asset/getIoConfigDetails/Succeeded':
            return {
                ...state,
                getIoConfigDetailsLoading: false,
                getIoConfigDetailsSuccess: true,
                getIoConfigDetailsFail: false,
                getIoConfigDetailsErrorCode: '',
                getIoConfigDetails: action.payload.configIoDetails,
            };
        case 'Asset/getIoConfigDetails/Failed':
            return {
                ...state,
                getIoConfigDetailsLoading: false,
                getIoConfigDetailsSuccess: false,
                getIoConfigDetailsFail: true,
                getIoConfigDetailsErrorCode: action.payload.errorCode,
            };
        case 'Asset/getIoConfigDetails/Unmounted':
            return {
                ...state,
                getIoConfigDetailsLoading: false,
                getIoConfigDetailsSuccess: false,
                getIoConfigDetailsFail: false,
                getIoConfigDetailsErrorCode: '',
            };

        case 'Asset/setIOConfiguration/Started':
            return {
                ...state,
                setIOConfigurationLoading: true,
                setIOConfigurationSuccess: false,
                setIOConfigurationFail: false,
                setIOConfigurationErrorCode: '',
                setIOConfigurationMessage: '',
            };
        case 'Asset/setIOConfiguration/Succeeded':
            return {
                ...state,
                setIOConfigurationLoading: false,
                setIOConfigurationSuccess: true,
                setIOConfigurationFail: false,
                setIOConfigurationErrorCode: '',
                setIOConfigurationMessage: action.payload.message,
            };
        case 'Asset/setIOConfiguration/Failed':
            return {
                ...state,
                setIOConfigurationLoading: false,
                setIOConfigurationSuccess: false,
                setIOConfigurationFail: true,
                setIOConfigurationErrorCode: action.payload.errorCode,
                setIOConfigurationMessage: '',
            };
        case 'Asset/setIOConfiguration/Unmounted':
            return {
                ...state,
                setIOConfigurationLoading: false,
                setIOConfigurationSuccess: false,
                setIOConfigurationFail: false,
                setIOConfigurationErrorCode: '',
                setIOConfigurationMessage: '',
            };

        default:
            return state;
    }
};
